module.exports = __webpack_public_path__ + "static/dragon-2416e376fccacb442153dbfa3bb62a4d.svg";